"use client";

import { useEffect, useRef, useState } from "react";

// Section whose CSS background photo only loads when it is about to scroll into view: the "bg-on" class
// switches the background image on (see .neon-band--leaf in globals.css). Full-quality image, just later.
export default function LazyBg({ as: Tag = "section", className = "", children, ...rest }) {
  const ref = useRef(null);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || on) return;
    if (!("IntersectionObserver" in window)) { setOn(true); return; }
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { setOn(true); io.disconnect(); } }, { rootMargin: "600px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [on]);
  return <Tag ref={ref} className={`${className}${on ? " bg-on" : ""}`} {...rest}>{children}</Tag>;
}
